import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "uk-container-large uk-margin-top border-outline" }
const _hoisted_2 = {
  class: "uk-grid-small",
  "data-uk-grid": ""
}
const _hoisted_3 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_4 = { class: "uk-inline uk-margin-top" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_7 = { class: "uk-inline" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_10 = { class: "uk-inline" }
const _hoisted_11 = { class: "uk-margin uk-width-1-1@s uk-width-1-1@l uk-width-1-1@xl uk-form-controls" }

import {getCurrentInstance, reactive, ref} from "vue";
import Stay from "@/models/Stay";
import * as dayjs from 'dayjs'
import {useStore} from "vuex";
import LoadingSpinner from "@/shared/components/loading/LoadingSpinner.vue";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'StayStep',
  emits: ['stayInfosSave'],
  setup(__props, { emit: __emit }) {

const { $alert } = getCurrentInstance().appContext.config.globalProperties;
  const { $axios } = getCurrentInstance().appContext.config.globalProperties;
  const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
  const stayType = ref([])
  const paymentType = ref([])
const store = useStore()
const emit = __emit

const bookDateDatas = store.getters['booking_filter/getRoomFilter']
const roomDatas = store.getters['room/getRoomChoose']
const stayOldData = store.getters['booking/getStay']
const stayForm = reactive<Stay>({
  stays_enter_date:bookDateDatas.arrival,
  stays_leaving_date:bookDateDatas.departure,
  customer_id:0,
  stay_type:stayOldData ==null?null:stayOldData.stay_type,
  stays_date:new Date(),
  is_booking: true,
  room_id:roomDatas.id,
  stays_number_of_children:0,
  stays_number_of_days:0,
  stays_number_of_occupants:bookDateDatas.guest,
  stays_preference:stayOldData ==null?'':stayOldData.stays_preference,
  stays_pay_off:false,
  stays_remaining_amount:0,
  stays_status:250,
  stays_vat:0,
  stays_total_price_to_pay:0,
  pay_mode:stayOldData ==null?'':stayOldData.pay_mode
})
const load = ref(false)
const isBooking = (arrival:Date)=>{
    const arrivalDate = dayjs(arrival)
    const dateNow = dayjs()
  return arrivalDate.isAfter(dateNow)
}

const getDaysNumber = (arrival:Date, departure:Date) => {
    const arrivalDate = dayjs(arrival)
    const departureDate = dayjs(departure)
  console.log(departureDate.diff(arrivalDate,'day',true))
  return departureDate.diff(arrivalDate,'day')
}
  $axios.get($endpoint.LoadStayType).then((res_type:any)=>{
    stayType.value = res_type.data
  })
  $axios.get($endpoint.LoadPaymentType).then((res_type:any)=>{
    paymentType.value = res_type.data
  })
const stayValidator = ()=>{
    return stayForm.stays_preference==''
        ||stayForm.stay_type==null
        ||stayForm.pay_mode==''
}
const calculStay =()=>{
    if (stayValidator()){
      $alert.fire({
        title: 'Ooops!',
        text: "Veuillez renseigné tout les champs",
        icon: 'error',
        confirmButtonColor:'#D62F2F',
        confirmButtonText: 'Compris'
      })

    }else {
      load.value = true
      stayForm.is_booking = isBooking(stayForm.stays_enter_date)
      stayForm.stays_number_of_days = getDaysNumber(stayForm.stays_enter_date,stayForm.stays_leaving_date)
      stayForm.stays_total_price_to_pay = stayForm.stays_number_of_days * roomDatas.room_total_price
      stayForm.stays_remaining_amount = stayForm.stays_total_price_to_pay
      store.dispatch('booking/saveStayData', stayForm)
      setTimeout(()=>{
        load.value =false

      },1000)
      emit('stayInfosSave')
      console.warn(stayForm)
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (load.value)
      ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createElementVNode("h6", { class: "uk-heading-line uk-text-center uk-text-secondary uk-text-uppercase uk-text-bold" }, [
      _createElementVNode("span", null, "Merci de compléter les informations concernant le séjour.")
    ], -1)),
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            class: "uk-form-label",
            for: "form-horizontal-text"
          }, "Type de séjour*", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((stayForm.stay_type) = $event)),
            class: "uk-select uk-input uk-form-width-large uk-border-rounded csa-input"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stayType.value, (stay_type) => {
              return (_openBlock(), _createElementBlock("option", {
                value: stay_type,
                key: stay_type.id
              }, _toDisplayString(stay_type.stay_typ_name), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, stayForm.stay_type]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[6] || (_cache[6] = _createElementVNode("label", {
            class: "uk-form-label",
            for: "form-horizontal-text"
          }, "Mode de paiement*", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((stayForm.pay_mode) = $event)),
            class: "uk-select uk-input uk-form-width-large uk-border-rounded csa-input"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentType.value, (pay_type) => {
              return (_openBlock(), _createElementBlock("option", {
                value: pay_type.pay_typ_name,
                key: pay_type.id
              }, _toDisplayString(pay_type.pay_typ_name), 9, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, stayForm.pay_mode]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[7] || (_cache[7] = _createElementVNode("span", {
            class: "uk-form-icon uk-form-icon-flip",
            "uk-icon": "icon: users"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((stayForm.stays_number_of_children) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Nombre d'enfant(s)",
            type: "number",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, stayForm.stays_number_of_children]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[8] || (_cache[8] = _createElementVNode("label", {
          class: "uk-form-label",
          for: "form-horizontal-text"
        }, "Préférence/Note", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((stayForm.stays_preference) = $event)),
          class: "uk-textarea uk-border-rounded csa-input",
          rows: "5",
          placeholder: "Préférence ou Note: Allergies, motricité, repas",
          "aria-label": "Textarea"
        }, null, 512), [
          [_vModelText, stayForm.stays_preference]
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "uk-button uk-button-large csa-btn uk-margin-left uk-text-center",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (calculStay()))
      }, "Valider")
    ])
  ]))
}
}

})